export default __webpack_public_path__ + "static/media/11-shine.c10083ce.png";